var sociallayerimages = {
    popupRequested: false,
    list: function(page){
        var params = {
            page: (page || 1),
            like: $('#sociallayerimages-list-like').val(),
            sociallayerimage_active: $("#sociallayerimages-list-active option:selected").val(),
        };

        var getParams = location.pathname+"?"+($.param(params));

        if(window.history && window.history.replaceState)
        {
            window.history.replaceState(null, null, getParams);

            $.get(getParams, params, function(resp){
                $("#sociallayerimages_list").html(resp);
            });
        } else {
            location.href=getParams;
        }
    },
    /**
     * Visszatér egy popup-pal, amivel id-től függően, létrehozható vagy módosítható egy provider
     * @param string screenID
     */

    /**
     * Terence: kísérleti jelleggel az összes nevén nevezett ID-t kicseréltem erre: requestedPrimaryKeyValue, mert így első ránézésre fölöslegesnek tartom,
     * hogy minden egyes x.js ajax file-nál minden egyes egyedi kulcsos változót kézzel átcopypaste-eljünk. Lehet, hogy rossz az elgondolásom, akkor majd átírom egyedi változónévre.
     */
    itemDetails: function(requestedPrimaryKeyValue){

        // Letiltjuk a dupla kattintas miatti dupla modal-megnyitast
        if( this.popupRequested ) return;
        this.popupRequested = true;

        var requestedPrimaryKeyValue = requestedPrimaryKeyValue || 0;
        $.post('/cat/socialLayerImages/itemDetails/' + requestedPrimaryKeyValue, {}, function(resp){
            popup(resp.html, resp.title).dialog();
            $('#openedSocialLayerImageID').val(requestedPrimaryKeyValue);
        }, 'json');
    },
    activate: function(requestedPrimaryKeyValue){
        var requestedPrimaryKeyValue = requestedPrimaryKeyValue || 0;

        $.post('/cat/socialLayerImages/activate/' + requestedPrimaryKeyValue, {}, function(resp)
        {
            location.reload();
        });
    },
    deactivate: function(requestedPrimaryKeyValue){
        var requestedPrimaryKeyValue = requestedPrimaryKeyValue || 0;

        $.post('/cat/socialLayerImages/deactivate/' + requestedPrimaryKeyValue, {}, function(resp)
        {
            location.reload();
        });
    },
    /**
     * Létrehoz vagy módosít egy provider-t az id-től függően.
     * @param string screenID
     */
    save: function(requestedPrimaryKeyValue){
        var requestedPrimaryKeyValue = requestedPrimaryKeyValue || '';
        var params = $('#sociallayerimage-popup-form, #sociallayerimageFile').find('select, input').serializeObj();

        $('#sociallayerimage-popup-success i').toggle('fast');

        $.post('/cat/socialLayerImages/save/' + requestedPrimaryKeyValue , params , function(){
            location.reload();
        }).fail(function(resp) {
            utils.error(resp.responseJSON);
            $('#sociallayerimage-popup-success i').toggle('fast')
        });
    },
};